import { UnderstandingLevel } from "@live-writing/models";

export function getUnderstandingLabel(level: UnderstandingLevel): string {
  switch (level) {
    case UnderstandingLevel.SOPHISTICATED:
      return "Sophisticated Understanding";
    case UnderstandingLevel.MODERATE:
      return "Moderate Understanding";
    case UnderstandingLevel.DEVELOPING:
      return "Developing Understanding";
    case UnderstandingLevel.INCOMPLETE:
      return "Incomplete";
    default:
      return "Unknown";
  }
}

export function getUnderstandingColor(level: UnderstandingLevel): string {
  switch (level) {
    case UnderstandingLevel.SOPHISTICATED:
      return "#39a432";
    case UnderstandingLevel.MODERATE:
      return "#9bb86d";
    case UnderstandingLevel.DEVELOPING: 
      return "#FB923C";
    case UnderstandingLevel.INCOMPLETE:
      return "#d76262";
    default:
      return "#6B7280";
  }
}
